<template>
  <div class="component-item">
    <label>Groups</label>
    <nav class="nav flex-column">
      <router-link :to="{ name: 'groups'}" class="nav-link">
        Groups
      </router-link>
    </nav>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  name: 'GroupsNav',
}
);
</script>

<style >
</style>
